import { render, staticRenderFns } from "./AppointmentWorkersAttached.vue?vue&type=template&id=6f881dfb"
import script from "./AppointmentWorkersAttached.vue?vue&type=script&lang=ts"
export * from "./AppointmentWorkersAttached.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentWorkersAttached.vue?vue&type=style&index=0&id=6f881dfb&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports